import { fmtEur } from './chequesApi';

export default function ChequeSummaryCards({ summary, isAdmin }) {
  if (!summary) return null;
  return (
    <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 mb-5" data-testid="cheque-summary-cards">
      <div className="bg-white border border-brand-border rounded-2xl p-4" data-testid="cheque-summary-por-receber">
        <p className="text-[11px] text-brand-muted mb-1">Total por receber</p>
        <p className="text-lg font-heading font-semibold text-brand-text">{fmtEur(summary.total_por_receber)}</p>
      </div>
      <div className="bg-brand-green/5 border border-brand-green/20 rounded-2xl p-4" data-testid="cheque-summary-recebido">
        <p className="text-[11px] text-brand-muted mb-1">Total já recebido</p>
        <p className="text-lg font-heading font-semibold text-brand-green">{fmtEur(summary.total_recebido)}</p>
      </div>
      <div className="bg-amber-50 border border-amber-200 rounded-2xl p-4" data-testid="cheque-summary-por-pagar">
        <p className="text-[11px] text-brand-muted mb-1">Por pagar à nutricionista</p>
        <p className="text-lg font-heading font-semibold text-amber-700">{fmtEur(summary.total_por_pagar_filipa)}</p>
      </div>
      <div className="bg-emerald-50 border border-emerald-200 rounded-2xl p-4" data-testid="cheque-summary-pago">
        <p className="text-[11px] text-brand-muted mb-1">Já pago à nutricionista</p>
        <p className="text-lg font-heading font-semibold text-emerald-700">{fmtEur(summary.total_pago_filipa)}</p>
      </div>
      {isAdmin && (
        <>
          <div className="bg-white border border-brand-border rounded-2xl p-4" data-testid="cheque-summary-retencao">
            <p className="text-[11px] text-brand-muted mb-1">Retenção suportada</p>
            <p className="text-lg font-heading font-semibold text-brand-text">{fmtEur(summary.retencao_suportada)}</p>
          </div>
          <div className="bg-brand-green/5 border border-brand-green/20 rounded-2xl p-4" data-testid="cheque-summary-margem">
            <p className="text-[11px] text-brand-muted mb-1">Margem da Ana</p>
            <p className="text-lg font-heading font-semibold text-brand-green">{fmtEur(summary.margem_ana)}</p>
          </div>
        </>
      )}
    </div>
  );
}
